<div class="setting-section">
  <h2>Agent Management</h2>
  <app-agent-mngt-detail
    [machines]="machines"
    [agentsData]="dataSource.data"
    (agentSaved)="onAgentSaved($event)"
  ></app-agent-mngt-detail>
  <mat-form-field>
    <input
      matInput
      type="text"
      (keyup)="doFilter($any($event.target).value)"
      placeholder="Filter by Username/SN"
    />
  </mat-form-field>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" class="agentsTable" matSort>
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
        <td mat-cell *matCellDef="let element">{{ element.username }}</td>
      </ng-container>
      <ng-container matColumnDef="machine">
        <th mat-header-cell *matHeaderCellDef>Machine SN</th>
        <td mat-cell *matCellDef="let element">
          {{ element.machineSerialNumber }}
        </td>
      </ng-container>
      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            [checked]="element.enabled"
            disabled="true"
          ></mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="lastSeenOnline">
        <th mat-header-cell *matHeaderCellDef>Last Seen Online</th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastSeenOnline | date: "medium" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="actionButtonCol">
          <button mat-raised-button color="primary" (click)="edit(element)">
            Edit
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="generatePwdConfirmDialog(element)"
            title="Generate and send new password"
          >
            Gen.Pwd
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="deleteConfirmDialog(element)"
          >
            Delete
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">No agents found"</td>
      </tr>
    </table>
  </div>
</div>
